import React from 'react'
import Image from 'next/image'

type Size = {
  width?: number
  height?: number
  className?: string
}

export const JeffMendez = ({ width, height, className }: Size) => {
  return (
    <Image
      src='/img/j-mendez.jpg'
      alt={'Jeff Mendez'}
      width={width ? width : 83}
      height={height ? height : 83}
      className={className}
      style={{ color: undefined }}
    />
  )
}
